import {
    FETCH_PRODUCT_CATEGORIES, CHANGE_PRODUCT_CATEGORY, GET_PRODUCTS, GET_PRODUCT_OPTIONS, GET_PRODUCT_MATERIALS, GET_PRODUCT_PRICING, GET_PRODUCT_COSTS, UPDATE_PRODUCT_PRICING, GET_BOOKLET_PRICING, UPDATE_BOOKLET_PRICING, UPDATE_PRODUCT_MATERIALS,
    GET_STICKER_PRICING, UPDATE_STICKER_PRICING, GET_MATERIAL_LIST, GET_PAYMENT_TERMS, ADD_PAYMENT_TERMS, REMOVE_PAYMENT_TERMS
} from '../actions/types';

const INIT_STATE = {
    prod_cat: [],
    products: [],
    pricing: [],
    // offline_pricing: [],
    materials: [],
    material_list: {},
    costs: [],
    options: null,
    selectedCat: '',
    payment_terms: {},
    term: '',
}

export default (state = INIT_STATE, action) => {
    let pricing;

    switch (action.type) {
        case FETCH_PRODUCT_CATEGORIES:
            return {
                ...state,
                prod_cat: action.payload
            }

        case CHANGE_PRODUCT_CATEGORY:
            return {
                ...state,
                selectedCat: action.payload
            }

        case GET_PRODUCTS:
            return { ...state, products: action.payload }

        case GET_PRODUCT_OPTIONS:
            return { ...state, options: action.payload }

        case GET_PRODUCT_MATERIALS:
        case UPDATE_PRODUCT_MATERIALS:
            return { ...state, materials: action.payload }

        case GET_PRODUCT_COSTS:
            return { ...state, costs: action.payload }

        case GET_PRODUCT_PRICING:
            pricing = action.payload;

            if (pricing && pricing[0]) {
                pricing[0].variants.forEach((item, index) => {
                    pricing[0].variants[index].edit = false;
                    pricing[0].variants[index].add = false;
                    pricing[0].variants[index].error = false;
                    pricing[0].variants[index].expand = true;
                })
            }

            return { ...state, pricing: action.payload }

        case UPDATE_PRODUCT_PRICING:
            pricing = [Object.assign({}, state.pricing[0])];

            if (action.payload !== null) {
                let index = pricing[0].variants.findIndex(el => el.id === action.payload._id);
                if (index >= 0) {
                    pricing[0].variants[index].edit = false;
                    pricing[0].variants[index].add = false;
                    pricing[0].variants[index].error = false;
                    pricing[0].variants[index].expand = true;
                    pricing[0].variants[index].prices = action.payload.prices;
                    pricing[0].variants[index].duration = action.payload.duration;
                    if (action.payload.duration_RC_PH) pricing[0].variants[index].duration_RC_PH = action.payload.duration_RC_PH;
                    if (action.payload.duration_HS) pricing[0].variants[index].duration_HS = action.payload.duration_HS;
                    return { ...state, pricing: pricing }
                } else {
                    return state;
                }
            } else {
                return state;
            }

        case UPDATE_BOOKLET_PRICING:
        case GET_BOOKLET_PRICING:
            console.log(action.payload);
            if (action.payload) {
                let defaults = {
                    edit: false,
                    add: false,
                    error: false,
                    expand: true
                }

                pricing = action.payload;

                if (pricing.material) pricing.material = Object.assign(pricing.material, defaults);

                if (pricing.printing) pricing.printing.forEach((printing, index) => pricing.printing[index] = Object.assign(printing, defaults));

                if (pricing.binding) pricing.binding.forEach((binding, index) => pricing.binding[index] = Object.assign(binding, defaults));
            } else {
                pricing = [];
            }
            return { ...state, pricing: pricing }

        case UPDATE_STICKER_PRICING:
        case GET_STICKER_PRICING:
            if (action.payload) {
                let defaults = {
                    edit: false,
                    add: false,
                    error: false,
                    expand: true
                }

                pricing = action.payload;

                pricing.material = Object.assign(pricing.material, defaults);
                pricing.plotting = Object.assign(pricing.plotting, defaults);
                console.log(pricing);
            } else {
                pricing = [];
            }
            return { ...state, pricing: pricing }

        case GET_MATERIAL_LIST:
            let material_list = {};
            if (action.payload) material_list[action.payload._id] = action.payload.values;
            return { ...state, material_list }

        case GET_PAYMENT_TERMS:
            return { ...state, payment_terms: action.payload }

        case ADD_PAYMENT_TERMS:
            if (action.payload) {
                console.log(action.payload);
                    return { ...state, payment_terms: action.payload.value}
            } else {
                return { ...state, status: 'Add Terms failed' }
            }

        case REMOVE_PAYMENT_TERMS:
            if (action.payload) {
                console.log(action.payload.value);
                return { ...state, payment_terms: action.payload.value }
            } else {
                return { ...state,status: 'Delete Terms failed'}
            }

        default:
            return state;
    }
}